// src/components/LightboxModal.js
import React, { useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import "./LightboxModal.css";

export default function LightboxModal({
  show = false,
  onHide,
  title = "",
  media = [],            // [{ type: "image"|"video"|"iframe", src }]
  startIndex = 0,        // index in the ORIGINAL media array
  interval = 5000,       // autoplay interval (ms)
}) {
  // Keep only images, but remember their original index
  const images = useMemo(
    () => media.map((m, i) => ({ ...m, _orig: i })).filter(m => m.type === "image"),
    [media]
  );

  // Map original startIndex to image index
  const mappedStartIndex = useMemo(() => {
    if (!images.length) return 0;
    const exact = images.findIndex(m => m._orig === startIndex);
    if (exact >= 0) return exact;
    const after = images.findIndex(m => m._orig >= startIndex);
    return after >= 0 ? after : 0;
  }, [images, startIndex]);

  const [index, setIndex] = useState(mappedStartIndex);

  useEffect(() => {
    if (show) setIndex(mappedStartIndex);
  }, [show, mappedStartIndex]);

  // If no images, don't render the modal
  if (!show || images.length === 0) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="xl"
      className="fm-lightbox"
      contentClassName="fm-lightbox-content"
      backdrop="static"   // prevent accidental close when swiping
    >
      <button className="fm-lightbox-close" onClick={onHide} aria-label="Close">
        ✕
      </button>

      {title ? <h2 className="fm-lightbox-title">{title}</h2> : null}

      <Carousel
        activeIndex={index}
        onSelect={setIndex}
        controls
        indicators
        interval={interval}
      >
        {images.map((m, i) => (
          <Carousel.Item key={m._orig ?? i}>
            <img
              className="lb-media"
              src={m.src}
              alt={`${title || "Image"} ${i + 1}`}
            />
            <Carousel.Caption>
              <span className="lb-counter">{i + 1} / {images.length}</span>
              {m.caption ? <p className="lb-caption">{m.caption}</p> : null}
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </Modal>
  );
}
